import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { cssVar, defineStyle } from "@chakra-ui/styled-system";

import { BUTTON_STYLES, createButtonVariant } from "../styles/button-styles";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  menuAnatomy.keys
);

const $bg = cssVar("menu-bg");
const $shadow = cssVar("menu-shadow");

const baseStyleList = defineStyle({
  [$bg.variable]: "brand.bg",
  bg: "brand.bg",
  [$shadow.variable]: "",
  py: 0,
  maxH: "sm",
  overflow: "auto",
  rounded: "base",
  borderWidth: "base",
  zIndex: "modal",
});

// FUTURE: Fix the border width applying on disabled menu items
const baseStyleItem = createButtonVariant({
  ...BUTTON_STYLES.variants.tertiary,
  bg: "brand.bg",
  _checked: {
    bg: "brand.selected",
  },
  fontWeight: "normal",
  rounded: "none",
  borderWidth: "0",
});

// Font size needs to be overriden like this because just using the style prop does not work
export const MENU_ITEM_STYLE_SX = {
  ".chakra-menu__menu-list .chakra-menu__icon-wrapper": {
    fontSize: "1em",
  },
};
const baseStyleIcon = defineStyle({
  boxSize: 6,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  color: "brand.clear_creek",
});

const baseStyleGroupTitle = defineStyle({
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "0",
});

const baseStyleCommand = defineStyle({});

const baseStyleDivider = defineStyle({});

const baseStyleButton = defineStyle({
  rounded: "base",
  borderWidth: "base",
  h: "button",
  zIndex: "base",
  p: 4,
  cursor: "pointer",
  _disabled: {
    cursor: "default",
    bg: "rgba(226,232,240, 0.2)",
  },
  transitionProperty: "common",
  transitionDuration: "normal",
});

const baseStyle = definePartsStyle({
  button: baseStyleButton,
  list: baseStyleList,
  item: baseStyleItem,
  groupTitle: baseStyleGroupTitle,
  command: baseStyleCommand,
  divider: baseStyleDivider,
  icon: baseStyleIcon,
});

export const menuTheme = defineMultiStyleConfig({ baseStyle });
